export default __webpack_public_path__ + "static/media/5.3a24902f.jpg";